export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./description.vue?vue&type=template&id=52b901b3"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/description/description.vue?vue&type=template&id=52b901b3
// module id = aY2i
// module chunks = 0